import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'ic-snacks'
import { useGoToAddStoreGroup } from 'legacy/sections/store-groups/utils/navigation.hooks'

export const StoreGroupsListAddButton: FunctionComponent = () => {
  const goToAddStoreGroup = useGoToAddStoreGroup()

  return (
    <Button
      onClick={goToAddStoreGroup}
      size="small"
      elementAttributes={{ 'data-testid': 'add-group-main-button' }}
    >
      <FormattedMessage id="settings.storeGroups.button.addNew" />
    </Button>
  )
}
